import React from "react";

export const ClockIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill="url(#paint0_linear_20616_13161)"
        fillOpacity="0.16"
      />
      <path
        d="M15.9993 24.3334C11.397 24.3334 7.66602 20.6024 7.66602 16.0001C7.66602 11.3977 11.397 7.66675 15.9993 7.66675C20.6017 7.66675 24.3327 11.3977 24.3327 16.0001C24.3327 20.6024 20.6017 24.3334 15.9993 24.3334ZM16.8327 16.0001V11.8334H15.166V17.6667H20.166V16.0001H16.8327Z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20616_13161"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};
